var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":("page-" + _vm.pageNumber)}},[_c('ul',{staticClass:"post-list"},_vm._l((_vm.pageObj),function(post){return (+post.status === 1)?_c('Post',{key:post.post_id,attrs:{"post":post}}):_vm._e()}),1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9403861a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thread/Page.vue
// module id = 723
// module chunks = 1